import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";
import { ElementType, lazy } from "react";

// Lazy load components for better code splitting
const Dashboard = lazy(() => import("../../admin/page/Dashboard/Dashboard"));
const Employee = lazy(() => import("../../admin/page/Staff/employee/Employee"));
const Role = lazy(() => import("../../admin/page/Staff/role/Role"));
const Units = lazy(() => import("../../admin/page/units/Units"));
const Branch = lazy(() => import("../../admin/page/branch/branch/Branch"));
const Mart = lazy(() => import("../../admin/page/branch/mart/Mart"));
const MartEmployee = lazy(
  () => import("../../admin/page/branch/martEmployee/MartEmployee"),
);
const MartRole = lazy(
  () => import("../../admin/page/branch/martRole/MartRole"),
);

type Route = {
  TITLE: string;
  ICON?: ElementType; // For React component icons
  KEY: number;
  PATH: string;
  ELEMENT?: ElementType; // For React page components like Dashboard, Employee, etc.
  DIRECT?: boolean;
  SUBNAV?: Route[]; // Recursive for nested menus
  SUBSUBNAV?: Route[]; // Further nesting if needed
};
export const ADMINROUTES: Route[] = [
  {
    TITLE: "Dashboard",
    ICON: AccountBalanceIcon,
    KEY: 1,
    PATH: "/admin/dashboard",
    ELEMENT: Dashboard,
  },

  {
    TITLE: "Staff",
    ICON: GroupIcon,
    KEY: 2,
    PATH: "/admin/staffs",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "Employees",
        KEY: 21,
        PATH: "/admin/staffs/employees",
        ELEMENT: Employee,
      },
      {
        TITLE: "Roles",
        KEY: 22,
        PATH: "/admin/staffs/roles",
        ELEMENT: Role,
      },
    ],
  },
  {
    TITLE: "Units",
    ICON: AccountBalanceIcon,
    KEY: 3,
    PATH: "/admin/units",
    ELEMENT: Units,
  },
  {
    TITLE: "Branch",
    ICON: GroupIcon,
    KEY: 4,
    PATH: "/admin/branch",
    DIRECT: true,
    SUBNAV: [
      {
        TITLE: "branches",
        KEY: 41,
        PATH: "/admin/branch/branch",
        ELEMENT: Branch,
      },
      {
        TITLE: "mart",
        KEY: 42,
        PATH: "/admin/branch/mart",
        ELEMENT: Mart,
      },
      {
        TITLE: "branch roles",
        KEY: 43,
        PATH: "/admin/branch/roles",
        ELEMENT: MartRole,
      },
      {
        TITLE: "branch employees",
        KEY: 44,
        PATH: "/admin/branch/employees",
        ELEMENT: MartEmployee,
      },
    ],
  },
  // {
  //   TITLE: "Staff",
  //   ICON: GroupIcon,
  //   KEY: 3,
  //   PATH: "/admin/staff",
  //   SUBNAV: [
  //     {
  //       TITLE: "Role",
  //       KEY: 31,
  //       PATH: "/admin/staff/role",
  //       SUBSUBNAV: [
  //         {
  //           TITLE: "Role",
  //           KEY: 311,
  //           PATH: "/admin/staff/role/role",
  //           ELEMENT: Role,
  //         },
  //         {
  //           TITLE: "Roles",
  //           KEY: 312,
  //           PATH: "/admin/staff/role/roles",
  //           ELEMENT: Employee,
  //         },
  //       ],
  //     },
  //     {
  //       TITLE: "Employee",
  //       KEY: 32,
  //       PATH: "/admin/staff/roles",
  //       ELEMENT: Employee,
  //     },
  //   ],
  // },
];

export default ADMINROUTES;
